if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');

                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

                this.hideErrors = this.dataset.hideErrors === 'true';

                this.additionalData = {
                    category: this.dataset.analyticsCategory,
                    format: this.dataset.analyticsFormat,
                    flavour: this.dataset.analyticsFlavour,
                };
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();

                const productCard = this.closest('.card');

                productCard
                    ? productCard.classList.toggle('card--loading')
                    : this.closest('product-info').classList.toggle('product__info-container--loading');

                this.classList.add('product-form--loading');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData(this.form);

                formData.append(
                    'properties[_subscription]',
                    !formData.get('properties[_subscription]') ? 'false' : formData.get('properties[_subscription]')
                );

                if (this.cart) {
                    formData.append(
                        'sections',
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                productVariantQuantity: formData.get('quantity'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });

                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute('aria-disabled', true);
                            this.submitButton.querySelector('span').classList.add('hidden');
                            soldOutMessage.classList.remove('hidden');
                            this.error = true;
                            return;
                        }

                        if (!this.error)
                            sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                productVariantQuantity: formData.get('quantity'),
                                cartData: response,
                            });

                        sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.cart, {
                            event: 'add_to_cart',
                            products: [response],
                            additionalData: {
                                ...this.additionalData,
                                productVariantQuantity: formData.get('quantity'),
                            },
                        });

                        this.error = false;
                        const quickAddModal = this.closest('quick-add-drawer');
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'quickAddClosed',
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.close(true);
                        } else {
                            this.cart.renderContents(response);
                        }

                        if (!response.status && !this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        productCard
                            ? productCard.classList.toggle('card--loading')
                            : this.closest('product-info').classList.toggle('product__info-container--loading');
                    });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper || document.querySelector('.product-form__container .global-message');
                if (!this.errorMessageWrapper) return;
                this.errorMessage =
                    this.errorMessage || this.errorMessageWrapper.querySelector('.global-message__copy');

                this.errorMessageWrapper.classList.toggle('global-message--active', errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}
